import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { BookableAsset } from '../assets/models/Asset';
import { useNavigationPaths } from '../propertyAssociation/useNavigationPaths';
import AssetItem from './components/AssetItem';
import { useBookableAssets } from './internalBookingService';

const SelectAsset: FunctionComponent = () => {
    const paths = useNavigationPaths();
    const navigate = useNavigate();
    const { assets, error } = useBookableAssets();

    const setAsset = (asset: BookableAsset) => {
        navigate(paths.newBookingForAsset(asset.assetId));
    };

    const sortedAssets = assets?.sort((a, b) => a.name.localeCompare(b.name)) ?? [];

    return (
        <div className="app__inner app__inner--center">
            <div className="text-center">
                <h1 className="large-heading">Vilken resurs vill du boka?</h1>
                <p className="preamble">I nästa steg väljer du ifall det är en intern- eller förmedlingsbokning som du vill göra.</p>
            </div>
            <div>
                {error && <div className="alert my-3 text-center">Kunde hitta några resurser. Vänligen försök igen.</div>}
                <div className="boxlist">
                    {sortedAssets.map((x) => (
                        <AssetItem key={x.assetId} asset={x} onClick={() => setAsset(x)} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SelectAsset;
